import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InventoryHeroComponent } from '../../Components/Inventory/inventory-hero/inventory-hero';
import { InventoryOverviewComponent } from '../../Components/Inventory/inventory-overview/inventory-overview';
import { InventoryFeaturesComponent } from '../../Components/Inventory/inventory-features/inventory-features';
import { SeoService } from '../../Shared/seo/seo.service';

@Component({
  selector: 'app-inventory-page',
  standalone: true,
  imports: [CommonModule, InventoryHeroComponent, InventoryOverviewComponent, InventoryFeaturesComponent],
  templateUrl: './inventory-page.html',
  styleUrls: ['./inventory-page.css'],
})
export class InventoryPageComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.update({
      title: 'Inventory Management Software',
      description:
        'Track items, prices, units, and warehouses in real time with orderYaa Inventory — low stock alerts, barcode price tags, and multi-warehouse stock, all in one system.',
      path: '/inventory',
    });
  }
}
